import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-required-asterisk',
  template: '<span *ngIf="show" class="required-asterisk">*</span>',
  styleUrls: ['./required-asterix.component.scss']
})
export class RequiredAsteriskComponent {
  @Input() show: boolean = false;
}